export default __webpack_public_path__ + "static/media/business-discussion.7f257566.jpg";